import IsoTimestamp from './IsoTimestamp';
import { format, toZonedTime } from 'date-fns-tz';
import { formatDateTime, DATE_FNS_PATTERN_TO_FORMAT_NAME } from '@modernloop/i18n';

const formatTZ = (date: IsoTimestamp, timeZone: string, formatString: string): string => {
  const name = DATE_FNS_PATTERN_TO_FORMAT_NAME[formatString];
  if (name) {
    return formatDateTime(date, name, { timeZone });
  }
  // Machine/allowlisted format (e.g. yyyy-MM-dd): keep raw, do not localize.
  return format(toZonedTime(new Date(date), timeZone), formatString, { timeZone });
};

export default formatTZ;
